// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"828b87c2","600":"a334e160","677":"c26ad45b"}[chunkId] + ".chunk.js";
};